<ng-container class="spinner-container">
	<div fxLayout="column" style="margin:16px;">
		<div fxFlex="5" fxLayout.lt-sm="column" fxLayoutAlign="start center" fxLayoutAlign.lt-sm="space-around" style="background-color: #242424;">
			<div fxLayout="row" style="margin:16px; color: #ffffff;letter-spacing: 0.2em;">
				<span class="material-icons" style="font-size: 40px;">account_circle</span>
				<div class="card-title" style="margin-left:12px;display: flex;justify-content: center;align-items: center;" translate>プロフィール</div>
			</div>
			<div fxLayout="row" style="font-size: 15px;margin: 16px 10px 5px 26px;color: #ffffff;" translate>お名前</div>
			<div fxLayout="row" style="margin:16px;background-color: #191919;">
				<div class="card-title" style="margin-left:12px;display: flex;justify-content: center;align-items: center;color: #ffffff;">{{nickname}}</div>
				<div style="font-size: 15px;padding:16px 16px 5px 16px;color: #ffffff;" translate>様</div>
			</div>
		</div>
		<div>
			<mat-card style="margin:5px;background: linear-gradient(#444444,#1d1d1d);">
				<mat-card-header>
					<mat-card-subtitle style="color: #ffffff;letter-spacing: 0.2em;font-weight: bold;"><span translate>ユーザープロフィール</span></mat-card-subtitle>
					<!-- <mat-card-title>{{nickname}}</mat-card-title>
					<mat-card-subtitle>{{type}}</mat-card-subtitle> -->
				</mat-card-header>
				<mat-card-content>

					<div [ngSwitch]="type">
						<div *ngSwitchCase="'company'">
							<app-company></app-company>
						</div>
						<div *ngSwitchCase="'studio'">
							<app-studio></app-studio>
						</div>
						<div *ngSwitchCase="'trainer'">
							<app-trainer></app-trainer>
						</div>
						<div *ngSwitchDefault>
							<app-user></app-user>
						</div>
					</div>

				</mat-card-content>
			</mat-card>
		</div>
	</div>
</ng-container>
